import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div``;

const PublicLayout = () => {
  return (
    <Container>
      <Outlet />
    </Container>
  );
};

export default PublicLayout;
